import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import { getClassNameFactory } from "../../../../../../utilities/classNames/";
import TabPanel from "./TabPanel";

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, childrenNode, reactifiedChildren, rehydratedProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("SiteHeaderFlyoutsTabPanel");
            childrenNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "children"
            })));
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            rehydratedProps = {
              tabTitle: domNode.getAttribute("data-tab-title"),
              id: domNode.getAttribute("id")
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(TabPanel, rehydratedProps, reactifiedChildren));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;